module.exports = __webpack_public_path__ + "img/code22.8d7398ed.png";